/**
 * Names that diversify a whole SECTOR (F11a, plan §3.3).
 *
 * Mean ρ of each outside candidate against every sector member, ascending — the
 * most negative mean first. This is the ~3 160-pair fan-out the API must serve
 * in ONE set-based statement (plan §6.6a); in local mode the same shape is an
 * in-memory reduce, which is why both modes can share this signature.
 */
import type { SectorDiversifier } from '@meridian/contracts';

import { corr, type FactorSecurity } from './correlation';

export function sectorDiversifiers(
  members: readonly FactorSecurity[],
  candidates: readonly FactorSecurity[],
  limit: number,
): readonly SectorDiversifier[] {
  if (members.length === 0 || limit <= 0) return [];
  const memberTickers = new Set(members.map((m) => m.ticker));
  return candidates
    .filter((c) => !memberTickers.has(c.ticker))
    .map((candidate) => ({
      ticker: candidate.ticker,
      meanRho: members.reduce((a, m) => a + corr(candidate, m), 0) / members.length,
    }))
    .sort((a, b) => a.meanRho - b.meanRho)
    .slice(0, limit);
}
